import * as types from '../../types'
import {
    API_URL,
    cencoEntity,
    presupuestoEntity
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import {
    toast
} from 'react-toastify';
import React from 'react'

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.CENCOS_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Cenco'
        const include = ['aprobador', 'presupuesto', 'presupuestos', 'users']
        const take = 100
        const filter = getState().cencos.getIn(['filter'])
        const fields = ['codigo', 'nombre', 'unidad_negocio', 'aprobador.name']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                skip,
                take,
                total: true
            })
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('cencos', 'cencos', list, page, records))
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalCreate(show, id = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (!show) {
            dispatch({
                type: types.CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE,
                payload: {
                    show
                }
            })
            return
        }

        const modelo = 'User'
        const include = []
        const filter = ''
        const fields = ['username', 'name', 'area']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                total: true
            })
            .then((res) => {
                const item = id ? getState().cencos.getIn(`cencos.data.${id}`.split('.')).toJS() : cencoEntity()
                const users = item.users.map(x => x.id)
                const list = res.data.data.map(x => {
                    x._enabled = true
                    x.selected = users.includes(x.id)
                    return x
                })
                const records = res.data.total
                dispatch({
                    type: types.CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE,
                    payload: {
                        show,
                        item
                    }
                })

                dispatch(tableActions.mswTable_mostrarDatos('cencos', 'modalCreate.data.tables.presupuestos', item.presupuestos, 1, item.presupuestos.length))

                dispatch(tableActions.mswTable_inicializar('cencos', 'modalCreate.data.tables.users', [{
                        ID: 0,
                        CAPTION: "",
                        VALUE: "selected",
                        TYPE: "selection",
                        INPUT: "checkbox",
                        WIDTH: 24,
                        FIXED: true
                    },
                    {
                        ID: 1,
                        CAPTION: "Identificacion",
                        VALUE: "username",
                        TYPE: "text"
                    },
                    {
                        ID: 2,
                        CAPTION: "Nombre",
                        VALUE: "name",
                        TYPE: "text"
                    },
                    {
                        ID: 3,
                        CAPTION: "Area",
                        VALUE: "area",
                        TYPE: "text"
                    }
                ], 'none', 1, 'selected'))
                dispatch(tableActions.mswTable_mostrarDatos('cencos', 'modalCreate.data.tables.users', list, 1, records))
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })

    }
}

export function guardarCenco() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('cencos', true))
        let data = getState().cencos.getIn(['modalCreate', 'data'])

        const v = String(data.get('activo')) === "true"
        data = data.set('activo', v ? true : false)
        data = data.set('presupuestos', data.getIn(`tables.presupuestos.data`.split('.')))
        data = data.set('users', data.getIn(`tables.users.data`.split('.')).filter(x => x.get('selected')).map(x => x.get('id')))
        data = data.delete('presupuesto')
        data = data.delete('tables')
        const id = data.get('id3n71f13r')

        axios.post(`${API_URL}/cencos`, data)
            .then(res => {
                const cenco = res.data
                cenco.enabled = true
                cenco.id3n71f13r = id
                dispatch({
                    type: types.CENCOS_ACTUALIZAR_REGISTROS,
                    payload: {
                        item: cenco,
                        id
                    }
                })
                dispatch(tableActions.mwsTable_recalcularAnchoColumnas('cencos', 'cencos'))
                dispatch(showHideModalCreate(false))
                dispatch(setSavingState('cencos', false))
                displayMessages(dispatch, {
                    success: 'Los registros han sido guardados exitosamente'
                })
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('parametros', false))
                displayMessages(dispatch, err)
            })

    }
}

export function showHideModalCreatePresupuesto(show, id = null) {
    return (dispatch, getState) => {
        const item = id ? getState().cencos.getIn(`modalCreate.data.tables.presupuestos.data.${id}`.split('.')).toJS() : presupuestoEntity()
        dispatch({
            type: types.CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE_PRESUPUESTO,
            payload: {
                show,
                item
            }
        })
    }
}

export function guardarPresupuesto() {
    return (dispatch, getState) => {
        const data = {
            _enabled: true,
            ...getState().cencos.getIn(`modalCreatePresupuesto.data`.split('.')).toJS()
        }

        const modelState = validateModel(data, [{
                key: 'periodo',
                conditions: `required|number|min:${(new Date().getFullYear())}|max:${(new Date().getFullYear()) + 3}`
            },
            {
                key: 'valor_total',
                conditions: 'required|number|min:0'
            },
            {
                key: 'valor_disponible',
                conditions: 'required|number|min:0'
            },
        ])

        if (modelState.length > 0) {
            modelState.forEach(x => {
                toast.warn(x.message)
            })
            return
        }

        if (data.id3n71f13r) {
            dispatch({
                type: types.CENCOS_ACTUALIZAR_PRESUPUESTOS
            })
        } else {
            dispatch(tableActions.mwsTable_agregarRegistros('cencos', 'modalCreate.data.tables.presupuestos', data))
        }
        dispatch(showHideModalCreatePresupuesto(false))
    }
}

export function filtrarTableLocally() {
    return (dispatch, getState) => {
        const search = getState().cencos.getIn(`modalCreate.data.tables.users.search`.split('.')).toLocaleLowerCase()
        const data = getState().cencos.getIn(`modalCreate.data.tables.users.data`.split('.')).valueSeq()
        const columns = getState().cencos.getIn(`modalCreate.data.tables.users.columns`.split('.')).filter(x => x.TYPE === 'text')
        const ids = data.map(x => {
            let show = false
            columns.forEach(y => {
                const value = x.get(y.VALUE)
                if (typeof value === 'string') {
                    show = show || value.toLocaleLowerCase().includes(search)
                }
            })
            return show ? x.get('id3n71f13r') : null
        }).filter(x => x)
        dispatch({
            type: types.CENCOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE,
            payload: ids
        })
    }
}

export function showHideModalCargarPresupuesto(show) {
    return (dispatch) => {
        dispatch({
            type: types.CENCOS_MOSTRAR_OCULTAR_MODAL_CARGAR_PRESUPUESTO,
            payload: {
                show
            }
        })
    }
}

export function cargarPresupuesto() {
    console.log('cargarPresupuesto')
    const axios = createAxiosInstance({ headers: {'content-type': 'multipart/form-data'}})
    return (dispatch, getState) => {
        let file = getState().cencos.getIn('modalCargarPresupuesto.data.file'.split('.')).toJS()
        if (file && file.value) {
            const f = file.files[0]
            let data = new FormData()
            data.append('file', f, f.name)
            axios.post(`${API_URL}/cencos/presupuesto`, data)
                .then(res => {
                    dispatch(getDataFromServer())
                    dispatch(showHideModalCargarPresupuesto(false))
                    dispatch(setSavingState('cencos', false))
                    displayMessages(dispatch, { success: res.data.Message })
                }).catch(err => {
                    console.log(err)
                    dispatch(setSavingState('cencos', false))
                    displayMessages(dispatch, err)
                })
        }

    }
}